import { render, staticRenderFns } from "./askExpertIndex.vue?vue&type=template&id=93599ac2&scoped=true"
import script from "./askExpertIndex.vue?vue&type=script&lang=js"
export * from "./askExpertIndex.vue?vue&type=script&lang=js"
import style0 from "./askExpertIndex.vue?vue&type=style&index=0&id=93599ac2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93599ac2",
  null
  
)

export default component.exports